import { Card, CardContent } from "../ui/card";
import { BarChart3, Users, Target, CheckCircle } from "lucide-react";

interface StatCardProps {
  title: string;
  value: number;
  change: number;
  unit?: string;
}

const getStatConfig = (title: string) => {
  switch (title) {
    case "Total assessments":
      return {
        icon: BarChart3,
        color: "bg-blue-100 text-blue-500",
      };
    case "Active candidates":
      return {
        icon: Users,
        color: "bg-green-100 text-green-500",
      };
    case "Average score":
      return {
        icon: Target,
        color: "bg-purple-100 text-purple-500",
      };
    case "Completion rate":
      return {
        icon: CheckCircle,
        color: "bg-orange-100 text-orange-500",
      };
    default:
      return {
        icon: BarChart3,
        color: "bg-blue-100 text-blue-500",
      };
  }
};

export function StatCard({ title, value, change, unit = "" }: StatCardProps) {
  const config = getStatConfig(title);
  const Icon = config.icon;

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center space-x-4">
          <div className={`p-2 rounded-md ${config.color}`}>
            <Icon className="w-4 h-4" />
          </div>
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">{title}</p>
            <div className="flex items-center space-x-2">
              <p className="text-2xl font-bold">
                {value}
                {unit}
              </p>
            </div>
            <p
              className={`text-sm ${
                change >= 0 ? "text-green-500" : "text-red-500"
              }`}
            >
              {change >= 0 ? "+" : ""}
              {change}%
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
